import React from "react";
import { useContextSafely } from "../../hooks";
import { IFiltersContext } from "./types";

export const FiltersContext = React.createContext<IFiltersContext<any> | null>(null);

export const FiltersProvider = FiltersContext.Provider;

export const useFiltersContext = <T extends string>() => {
    return useContextSafely<IFiltersContext<T>>(FiltersContext);
};
